import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from "./../../Header";
import $ from "jquery";
import "react-infinite-calendar/styles.css"; // Make sure to import the default stylesheet
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import Pagination from "react-js-pagination";
import { AgGridReact } from "ag-grid-react";
import "../feature/feature.css";
var datestring = moment().format("YYYY-MM");
class Revenue extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			enterprise_server_id: "",
			enterprise: "",
			curr_month: datestring,
			str_month: [],
			datepicker_resume: false,
			resumeDate: "",
			date_of_resume_after_pause: "",
			resume_package_checkbox_checked: "",
			resume_is_date_present: "",
			unchecked_apps: [],
			resume_unchecked_apps: [],
			checked_class_package: "",
			date_of_resume: "",
			checked_package: "",
			paused_billing_date: "",
			app_data: "",
			resume_app_data: "",
			paused_studio_id: "",
			searchsubscription: "",
			subscription_list: [],
			paused_applications: [],
			resume_applications: [],
			package_details: "",
			resume_package_details: "",
			studio_id: "",
			user_id: "",
			sub_search: "",
			isLoadMore: 1,
			activePage: 1,
			loading: 1,
			item_count: "",
			fields: {},
			errors: {},
			apps: {},
			invoice_title: "",
			is_package_check_state: 1,
			checked: true,
			resume_check: 0,
			datepicker: true,
			apiUrl: this.decryptconfigdata("apiUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			userEmail: has_local_data ? localdata.user_email : "",
			servers: [],
			paginationPageSize: 10,
			columns: [
				{
					headerName: "Company",
					field: "company_name",
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					cellRenderer: (row) => (
						<div>
							{row.data.server_id == 0 ? (
								<Link key={row.data.studio_id} to={`/account/${row.data.studio_id}`} name={"max"}>
									{" "}
									{row.data.company_name}
								</Link>
							) : (
								<Link key={row.data.studio_id} to={`/account/${row.data.studio_id}`} name={"max"}>
									{" "}
									{row.data.company_name}
								</Link>
							)}
						</div>
					),
					floatingFilter: true,
					width: 240,
				},
				{
					headerName: "Package",
					field: "key_customer",
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					cellRenderer: (row) => (
						<div>
							{row.data.highvalue == 1 ? (
								<span>
									{row.data.packagename},
									<span style={{ color: "#006efa", fontSize: "11px" }}> Key Account</span>
								</span>
							) : (
								row.data.packagename
							)}
						</div>
					),
					floatingFilter: true,
					width: 270,
				},
				{
					headerName: "Payment Frequency",
					field: "plan_interval",
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 200,
				},
				{
					headerName: "Payment Date",
					field: "transaction_date",
					cellRenderer: function (row) {
						return row.data.transaction_date && row.data.transaction_date != ""
							? row.data.transaction_date
							: "N/A";
					},
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 180,
				},
				{
					headerName: "Paid Till Last Month",
					field: "amount_paid_till_last_month",
					cellRenderer: function (row) {
						return row.data.amount_paid_till_last_month
							? "$" + row.data.amount_paid_till_last_month
							: "$0.00";
					},
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 190,
				},
				{
					headerName: "Current Month Invoice",
					field: "current_invoice_amt",
					cellRenderer: function (row) {
						return row.data.current_invoice_amt ? "$" + row.data.current_invoice_amt : "$0.00";
					},
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 220,
				},
				{
					headerName: "Current Month Realized",
					field: "current_realized_amount",
					cellRenderer: function (row) {
						return row.data.current_realized_amount ? "$" + row.data.current_realized_amount : "$0.00";
					},
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 220,
				},
				{
					headerName: "Next Payment",
					field: "next_payment_amount",
					cellRenderer: function (row) {
						return row.data.next_payment_amount ? "$" + row.data.next_payment_amount : "$0.00";
					},
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 170,
				},
				{
					headerName: "Next Payment Date",
					field: "start_date",
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 200,
				},
				{
					headerName: "Payment Method",
					field: "payment_method",
					suppressMenu: true,
					sortable: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 180,
				},
				{
					headerName: "Status",
					field: "is_paused",
					suppressMenu: true,
					sortable: true,
					cellRenderer: (row) => (
						<div>
							{row.data.is_paused == "Paused" ? (
								<span style={{ color: "red" }}>Paused</span>
							) : (
								<span>Paying</span>
							)}
						</div>
					),
					//autoHeight: true,
					filter: "agTextColumnFilter",
					floatingFilter: true,
					width: 130,
				},
				{
					headerName: "Action",
					cellRenderer: (row) => (
						<div class="revenue" style={{ fontSize: "16px" }}>
							<span
								onClick={() => this.customer_details(row.data.studio_id, row.data.user_id)}
								data-toggle="modal"
								data-target="#raiseInvoiceModal"
								class="icon tooltips ag-link"
							>
								<a
									href="javascript:void(0);"
									data-toggle="tooltip"
									data-placement="top"
									title="Raise Custom Invoice"
								>
									<i class="far fa-usd-square"></i>
								</a>
							</span>

							{row.data.is_paused == "Paused" ? (
								<span
									onClick={() => this.resume_billing_details(row.data.studio_id)}
									class="icon rght tooltips"
									data-toggle="modal"
									data-target="#resumeBillingModal"
								>
									<a
										href="javascript:void(0);"
										data-toggle="tooltip"
										data-placement="left"
										title="Resume Billing"
									>
										<i class="fal fa-play-circle"></i>
									</a>
								</span>
							) : (
								<span
									onClick={() => this.pause_billing_details(row.data.studio_id)}
									class="icon rght tooltips"
									data-toggle="modal"
									data-target="#pauseBillingModal"
								>
									<a
										href="javascript:void(0);"
										data-toggle="tooltip"
										data-placement="top"
										title="Pause Billing"
									>
										<i class="fal fa-pause-circle"></i>
									</a>
								</span>
							)}

							{row.data.payment_method && row.data.payment_method == "Wire transfer" ? (
								row.data.billing_uniqid && row.data.billing_uniqid.trim() ? (
									<span
										class="icon rght tooltips"
										onClick={() =>
											this.confirmWireTransfer(row.data.studio_id, row.data.billing_uniqid)
										}
									>
										<a
											href="javascript:void(0);"
											data-toggle="tooltip"
											data-placement="top"
											title="Confirm Wire Transfer"
										>
											<i class="far fa-square"></i>
										</a>
									</span>
								) : (
									<span class="icon rght tooltips">
										<i
											class="far fa-check-square"
											data-toggle="tooltip"
											data-placement="top"
											title="Paid"
										></i>
									</span>
								)
							) : row.data.billing_uniqid && row.data.billing_uniqid.trim() ? (
								<span onClick={() => this.confirmCreditcardTransfer()}>
									<a
										href="javascript:void(0);"
										class="icon already_paid cnfrm_wt"
										data-toggle="tooltip"
										data-placement="top"
										title="Credit Card Transfer"
									>
										<i class="far fa-square"></i>
									</a>
								</span>
							) : (
								<span class="icon already_paid" data-toggle="tooltip" data-placement="top" title="Paid">
									<i class="far fa-check-square"></i>
								</span>
							)}
						</div>
					),

					suppressMenu: true,
					// sortable: true,
					//autoHeight: true,
					filter: "agTextColumnFilter",
					// floatingFilter: true,
					width: 120,
				},
			],
		};
		this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
		this.searchChange = this.searchChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.customer_details = this.customer_details.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
		this.handleResumeDate = this.handleResumeDate.bind(this);
		this.handleResumeDateAfterPause = this.handleResumeDateAfterPause.bind(this);
		this.resumeOn = this.resumeOn.bind(this);
		this.auto_resumeOn = this.auto_resumeOn.bind(this);
		this.checkUncheckAllApp = this.checkUncheckAllApp.bind(this);
		this.checkUncheckAllResumeApp = this.checkUncheckAllResumeApp.bind(this);
		this.checkApplications = this.checkApplications.bind(this);
		this.checkResumeApplications = this.checkResumeApplications.bind(this);
		// this.onMonthChange = this.onMonthChange.bind(this);
		// this.onEnterpriseChange = this.onEnterpriseChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
	}

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	handleResumeDate(date) {
		this.setState({
			date_of_resume: date,
			resume_date: moment(date).format("MM/DD/YYYY"),
		});
	}

	handleResumeDateAfterPause(date) {
		this.setState({
			resumeDate: date,
			resumeDateNew: moment(date).format("MM/DD/YYYY"),
		});
	}

	checkUncheckAllApp() {
		var chk = document.getElementById("package_id");
		var resume = document.getElementById("resume_id");
		if (chk.checked == true) {
			var app = document.getElementsByName("checked_application");
			for (var i = 0; i < app.length; i++) {
				if (app[i].name == "checked_application") app[i].checked = true;
				this.state.unchecked_apps = "";
			}
			resume.disabled = true;
			resume.checked = false;
			this.setState({ datepicker: true, date_of_resume: "" });
		} else {
			var app = document.getElementsByName("checked_application");
			var resume = document.getElementById("resume_id");
			for (var i = 0; i < app.length; i++) {
				if (app[i].name == "checked_application") app[i].checked = false;
				this.state.unchecked_apps += app[i].value + ",";
			}
			resume.disabled = false;
		}
	}

	checkUncheckAllResumeApp() {
		var chk = document.getElementById("resume_package_id");
		if (chk.checked == true) {
			var app = document.getElementsByClassName("resume_selappchk");
			for (var i = 0; i < app.length; i++) {
				if (app[i].className == "resume_selappchk") app[i].checked = true;
				this.state.resume_unchecked_apps += app[i].value + ",";
			}
		} else {
			var app = document.getElementsByClassName("resume_selappchk");
			for (var i = 0; i < app.length; i++) {
				if (app[i].className == "resume_selappchk") app[i].checked = false;
				this.state.resume_unchecked_apps = "";
			}
		}
	}

	resumeOn() {
		var resume = document.getElementById("resume_id");
		if (resume.checked == true) {
			this.setState({ datepicker: false, resume_check: 1 });
		} else {
			this.setState({ datepicker: true, date_of_resume: "" });
		}
	}

	auto_resumeOn() {
		var resume = document.getElementById("auto_resume_id");
		if (resume.checked == true) {
			this.setState({ datepicker_resume: false });
		} else {
			this.setState({ datepicker_resume: true, resumeDate: "" });
		}
	}

	checkApplications() {
		var app = document.getElementsByName("checked_application");
		var len = app.length;
		var count = 0;
		var atleast_checked = 0;
		this.state.unchecked_apps = "";
		for (var i = 0; i < app.length; i++) {
			if (app[i].checked === true) {
				count++;
				document.getElementById("package_id").checked = false;
				document.getElementById("resume_id").disabled = false;
				document.getElementsByClassName("selappchk").checked = false;
				if (count == len) {
					document.getElementById("package_id").checked = true;
					document.getElementById("resume_id").disabled = true;
					document.getElementById("resume_id").checked = false;
					this.setState({ datepicker: true, date_of_resume: "" });
				}
				atleast_checked = 1;
			} else {
				this.state.unchecked_apps += app[i].value + ",";
			}
		}
		if (!atleast_checked) {
			document.getElementById("package_id").checked = false;
			document.getElementById("resume_id").disabled = false;
			document.getElementsByClassName("selappchk").checked = false;
		}
	}

	checkResumeApplications() {
		var app = document.getElementsByClassName("resume_selappchk");
		var len = app.length;
		var count = 0;
		this.state.resume_unchecked_apps = "";
		for (var i = 0; i < app.length; i++) {
			if (app[i].checked === true) {
				this.state.resume_unchecked_apps += app[i].value + ",";
				count++;
				if (count == len) {
					document.getElementById("resume_package_id").checked = true;
				}
			}
		}
		if (count != len) {
			document.getElementById("resume_package_id").checked = false;
		}
	}

	handleValidation() {
		let fields = this.state.fields;
		let errors = {};
		let formIsValid = true;
		if (!fields["invoice_title"]) {
			formIsValid = false;
			errors["invoice_title"] = "This field is required.";
		}
		if (!fields["invoice_description"]) {
			formIsValid = false;
			errors["invoice_description"] = "This field is required.";
		}
		if (!fields["invoice_amount"]) {
			formIsValid = false;
			errors["invoice_amount"] = "This field is required.";
		}
		if (fields["invoice_amount"] && !this.isValidNumber(fields["invoice_amount"])) {
			formIsValid = false;
			errors["invoice_amount"] = "Invalid Amount";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	handleValidationPauseBilling() {
		let errors = {};
		let formIsValid = true;
		let applications = this.state.paused_applications;

		var resume = document.getElementById("resume_id");
		var pack = document.getElementById("package_id");
		if (applications.length != 0) {
			if (pack.checked == true && resume.checked == false) {
				formIsValid = false;
				errors["resume_unchecked"] = "No Applications are un-selected";
			}
			if (pack.checked == false && resume.checked == true && this.state.date_of_resume == "") {
				formIsValid = false;
				errors["resume_unchecked"] = "Please enter resume date";
			}
		} else {
			formIsValid = false;
			errors["resume_unchecked"] = "No Package is un-selected";
		}

		this.setState({ errors: errors });
		return formIsValid;
	}

	handleValidationResumeBilling() {
		let errors = {};
		let formIsValid = true;

		var app = document.getElementsByClassName("resume_selappchk");
		var count = 0;
		for (var i = 0; i < app.length; i++) {
			if (app[i].checked === true) {
				count++;
			}
		}
		if (count == 0) {
			formIsValid = false;
			errors["resume_billing_error"] = "No Applications are selected";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	spaceKeyPress(event) {
		if (event.which == 32 && !event.target.value.length) {
			event.preventDefault();
		}
	}

	isValidNumber(number) {
		var pattern = /^[0-9]*\.?[0-9]*$/;
		return pattern.test(number);
	}

	onChange(event) {
		let fields = this.state.fields;
		this.setState({ [event.target.name]: event.target.value });
		fields[event.target.name] = event.target.value;
	}

	searchChange(event) {
		// document.getElementById('enterprise').value = ''
		this.setState(
			{
				//     enterprise: '',
				activePage: 1,
				subscription_list: [],
				loading: 1,
				searchsubscription: event.target.value,
			},
			function () {
				this.SubscriptionList();
			}
		);
	}
	keywordChange(event) {
		var obj = this;
		this.setState({ sub_search: event.target.value });
		//Delaying the function execute
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
		this.timer = window.setTimeout(function () {
			//Execute the function code here...
			obj.SubscriptionList();
		}, 500);
	}
	confirmWireTransfer(studio_id, billing_unique_id) {
		if (window.confirm("Are you sure customer credited the payment to Muvi?")) {
			// fetch(this.state.apiUrl + '/RevenueRest/confirmManualPayment/userAuthKey/' + this.state.userAuthKey + '/studio_id/' + studio_id + '/billing_uniqid/' + billing_unique_id + '/server_id/' + this.state.enterprise_server_id, {
			fetch(
				this.state.apiUrl +
				"/RevenueRest/confirmManualPayment/userAuthKey/" +
				this.state.userAuthKey +
				"/studio_id/" +
				studio_id +
				"/billing_uniqid/" +
				billing_unique_id,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						window.location.href = "/revenue";
					}
				});
		}
	}
	//ER:#31282
	confirmCreditcardTransfer() {
		alert("You are not authorize to generate invoice for credit card payment.");
	}
	customer_details(studio_id, user_id) {
		// fetch(this.state.apiUrl + '/RevenueRest/CustomerdDetail/studio_id/' + studio_id + '/userAuthKey/' + this.state.userAuthKey + '/user_id/' + user_id + '/server_id/' + this.state.enterprise_server_id, {
		fetch(
			this.state.apiUrl +
			"/RevenueRest/CustomerdDetail/studio_id/" +
			studio_id +
			"/userAuthKey/" +
			this.state.userAuthKey +
			"/user_id/" +
			user_id,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					studio_id: findresponse.studio_id,
					user_id: findresponse.user_id,
				});
			});
	}

	pause_billing_details(studio_id) {
		// fetch(this.state.apiUrl + '/RevenueRest/pauseBillingDetail/studio_id/' + studio_id + '/userAuthKey/' + this.state.userAuthKey + '/server_id/' + this.state.enterprise_server_id, {
		fetch(
			this.state.apiUrl +
			"/RevenueRest/pauseBillingDetail/studio_id/" +
			studio_id +
			"/userAuthKey/" +
			this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					paused_studioPlans: findresponse.studioPlans,
					package_details: findresponse.package,
					paused_applications: findresponse.applications,
					paused_selapps: findresponse.selapps,
					paused_billing_date: findresponse.billing_date,
					paused_studio_id: findresponse.studio_id,
					paused_package: findresponse.paused_package,
					paused_app: findresponse.paused_app,
					app_data: findresponse.app_data,
					checked_package: findresponse.checked_package,
					checked_class_package: findresponse.checked_class_package,
				});
				var chk = document.getElementById("package_id");
				if (this.state.checked_package == 0 && this.state.checked_class_package == 0) {
					chk.setAttribute("class", "");
					document.getElementById("package_id").checked = false;
				} else if (this.state.checked_package == 1) {
					chk.setAttribute("disabled", "disabled");
					document.getElementById("package_id").checked = true;
				} else if (this.state.checked_package == 2 && this.state.checked_class_package == 3) {
					document.getElementById("package_id").checked = true;
					chk.setAttribute("class", "checkallapp");
				} else if (this.state.checked_class_package == 3) {
					chk.setAttribute("class", "checkallapp");
				}

				document.getElementById("resume_id").disabled = true;
				document.getElementById("resume_id").checked = false;
				this.setState({
					datepicker: true,
					date_of_resume: "",
					errors: "",
					unchecked_apps: [],
					resume_date: "",
				});
				document.getElementById("pause_billing").disabled = false;
				var applications = this.state.paused_applications;
				var getapps = document.getElementsByClassName("appchk");
				for (var i = 0; i < getapps.length; i++) {
					if (applications[i].is_selapps == 1) {
						getapps[i].checked = true;
					} else {
						getapps[i].checked = false;
					}
				}
			});
	}

	resume_billing_details(studio_id) {
		// fetch(this.state.apiUrl + '/RevenueRest/resumeBillingDetail/studio_id/' + studio_id + '/userAuthKey/' + this.state.userAuthKey + '/server_id/' + this.state.enterprise_server_id, {
		fetch(
			this.state.apiUrl +
			"/RevenueRest/resumeBillingDetail/studio_id/" +
			studio_id +
			"/userAuthKey/" +
			this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					resume_studioPlans: findresponse.studioPlans,
					resume_package_details: findresponse.package,
					resume_applications: findresponse.applications,
					resume_selapps: findresponse.selapps,
					resume_PauseBilling: findresponse.PauseBilling,
					resume_selpausedapps: findresponse.selpausedapps,
					resume_billing_date: findresponse.billing_date,
					resume_studio_id: findresponse.studio_id,
					resume_app_data: findresponse.app_data,
					resume_is_date_present: findresponse.is_date_present,
					resume_package_checkbox_checked: findresponse.package_checkbox_checked,
					date_of_resume_after_pause: findresponse.resume_datepicker_new,
				});

				if (this.state.date_of_resume_after_pause != "0000-00-00") {
					let x = Date.parse(this.state.date_of_resume_after_pause);
					this.setState({ resumeDate: moment(x) });
				}

				if (this.state.resume_package_checkbox_checked == 1) {
					document.getElementById("resume_package_id").checked = true;
				} else {
					document.getElementById("resume_package_id").checked = false;
				}

				this.setState({ errors: "" });

				var applications = this.state.resume_applications;
				var getapps = document.getElementsByClassName("resume_appchk");
				for (var i = 0; i < getapps.length; i++) {
					if (applications[i].resume_is_paused_app == 0 && applications[i].resume_is_selapps == 1) {
						getapps[i].checked = true;
					} else {
						getapps[i].checked = false;
					}
				}
			});
	}

	getAllServer() {
		fetch(this.state.apiUrl + "/RevenueRest/GetAllServer/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					servers: findresponse.servers,
				});
			});
	}
	//ER#73448 Revenue AG Grid start
	onPageSizeChanged = (event) => {
		this.setState({ paginationPageSize: event.target.value });
		this.gridApi.paginationSetPageSize(Number(event.target.value));
	};
	onGridReady = (params) => {
		this.gridApi = params.api;
		this.columnApi = params.columnApi;
		//this.gridApi.sizeColumnsToFit();
	};
	searchGrid = (event) => {
		const { name, value } = event.target;
		this.gridApi.setQuickFilter(value);
	};

	// AG grid end

	getSubscriptionDetails() {
		if (this.state.loading) {
			return (
				<div>
					<div class="loader-new"></div>
				</div>
			);
		} else {
			return (
				<div>
					<div className="ag-theme-material" style={{ height: "90vh" }}>
						<AgGridReact
							rowData={this.state.subscription_list}
							columnDefs={this.state.columns}
							pagination={true}
							resizable={true}
							//suppressHorizontalScroll={true}
							//fullWidthCellRenderer= {this.fullWidthCellRenderer}
							paginationPageSize={this.state.paginationPageSize}
							onGridReady={this.onGridReady}
						// domLayout='autoHeight'
						/>
					</div>
					<div className="aggrid_custom_page">
						Page Size
						<select
							style={{ borderColor: "#e6e2e2", fontSize: "13px", color: "#484848" }}
							onChange={(e) => this.onPageSizeChanged(e)}
							value={this.state.paginationPageSize}
						>
							<option value="10" selected={true}>
								10
							</option>
							<option value="50">50</option>
							<option value="100">100</option>
						</select>
					</div>
				</div>
			);
		}
	}

	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center">No Data Found</div>;
		}
	}

	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		fetch(
			this.state.apiUrl +
			"/RevenueRest/RevenueList/userId/" +
			this.state.userId +
			"/userAuthKey/" +
			this.state.userAuthKey +
			"/page/" +
			pageNumber,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.subscription_list.length == 0) {
					this.setState({
						isLoadMore: 2,
					});
				} else {
					this.setState({
						isLoadMore: 1,
					});
				}
				this.setState({
					subscription_list: this.state.subscription_list.concat(findresponse.subscription_list),
				});
			});
	}

	handlePageChange(pageNumber = 1) {
		var totalPages = Math.ceil(this.state.item_count / 20);
		if (this.state.activePage != pageNumber) {
			$(document).ready(function () {
				$(".pages").addClass("disabled");
			});
			this.setState({ activePage: pageNumber, setPage: "no" });
			fetch(
				this.state.apiUrl +
				"/RevenueRest/RevenueList/page/" +
				pageNumber +
				"/userAuthKey/" +
				this.state.userAuthKey +
				"/userId/" +
				this.state.userId,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					$(document).ready(function () {
						$(".pages").removeClass("disabled");
						if (pageNumber == 1) {
							$(".first_page").addClass("disabled");
							$(".prev_page").addClass("disabled");
						}
						if (pageNumber == totalPages) {
							$(".next_page").addClass("disabled");
							$(".last_page").addClass("disabled");
						}
					});
					this.setState({
						subscription_list: findresponse.subscription_list,
						// offset: findresponse.offset,
						// off_count: findresponse.off_count,
						setPage: "yes",
					});
				});
		}
	}

	SubscriptionList(page = 1) {
		fetch(
			this.state.apiUrl +
			"/RevenueRest/RevenueList/page/" +
			page +
			"/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					subscription_list: findresponse.subscription_list,
					item_count: findresponse.item_count,
					loading: 0,
					hidden_column: findresponse.hidden_column,
					quick_stats: findresponse.quick_stats,
					current_stats: findresponse.current_stats,
					projected_revenue: findresponse.projected_revenue,
					str_month: findresponse.str_month,
					custmerid: findresponse.custmerid,
					enterprise_server_id: findresponse.enterprise_server_id,
					// offset: findresponse.offset,
					// off_count: findresponse.off_count,
					setPage: "yes",
				});
			});
	}

	submitInvoice() {
		if (this.handleValidation()) {
			//return true;
		} else {
			return false;
		}
		document.getElementById("submit_invoice").innerHTML = "Sending....";
		const fd = new FormData();
		document.getElementById("submit_invoice").disabled = true;
		fd.append("invoice_inputs", JSON.stringify(this.state));
		// fetch(this.state.apiUrl + '/RevenueRest/RaiseInvoice/userAuthKey/' + this.state.userAuthKey + '/server_id/' + this.state.enterprise_server_id, {
		fetch(this.state.apiUrl + "/RevenueRest/RaiseInvoice/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: fd,
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				document.getElementById("submit_invoice").innerHTML = "Submit";
				if (findresponse.code == 200) {
					window.location.href = "/revenue";
				}
			});
	}

	pauseBilling() {
		if (this.handleValidationPauseBilling()) {
		} else {
			return false;
		}
		if (window.confirm("Are you sure you want to pause billing?")) {
			const fd = new FormData();
			document.getElementById("pause_billing").disabled = true;
			fd.append("pause_billing_inputs", JSON.stringify(this.state));
			// fetch(this.state.apiUrl + '/RevenueRest/pauseBilling/userAuthKey/' + this.state.userAuthKey + '/server_id/' + this.state.enterprise_server_id, {
			fetch(this.state.apiUrl + "/RevenueRest/pauseBilling/userAuthKey/" + this.state.userAuthKey, {
				method: "POST",
				dataType: "json",
				body: fd,
			})
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					document.getElementById("pause_billing").innerHTML = "Submit";
					if (findresponse.code == 200) {
						window.location.href = "/revenue";
					}
				});
		}
	}

	resumeBilling() {
		if (this.handleValidationResumeBilling()) {
		} else {
			return false;
		}
		if (window.confirm("Are you sure you want to resume billing?")) {
			const fd = new FormData();
			document.getElementById("resume_billing_button").disabled = true;
			fd.append("resume_billing_inputs", JSON.stringify(this.state));
			// fetch(this.state.apiUrl + '/RevenueRest/resumeBilling/userAuthKey/' + this.state.userAuthKey + '/server_id/' + this.state.enterprise_server_id, {
			fetch(this.state.apiUrl + "/RevenueRest/resumeBilling/userAuthKey/" + this.state.userAuthKey, {
				method: "POST",
				dataType: "json",
				body: fd,
			})
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					document.getElementById("resume_billing_button").innerHTML = "Submit";
					if (findresponse.code == 200) {
						window.location.href = "/revenue";
					}
				});
		}
	}

	// onMonthChange(event) {
	//     document.getElementById('enterprise').value = ''
	//     this.setState({
	//         enterprise: '',
	//         curr_month: event.target.value, activePage: 1,
	//         subscription_list: [],
	//         loading: 1,
	//     }, function () {
	//         this.SubscriptionList();
	//     });
	// }

	// onEnterpriseChange(event) {
	//     document.getElementById('revenue_search').value = '';
	//     let enterprise = document.getElementById('enterprise').value;
	//     this.setState({
	//         searchsubscription: '',
	//         [event.target.name]: event.target.value,
	//         activePage: 1,
	//         subscription_list: [],
	//         loading: 1,
	//         enterprise: enterprise
	//     }, function () {
	//         this.SubscriptionList();
	//     });
	// }

	componentDidMount() {
		// this.getAllServer();
		document.title = "Intranet | Subscription";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}

		this.SubscriptionList();
		$(".searchTicket.dept").on("click", function () {
			$(this).closest(".right-section").find(".filter_dept").slideToggle("slow");
		});
	}
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				<Header brecum_name="Customer" brecum_page="Customer" />
				<div class="right_col">
					<div class="intranet_body">
						<div id="exTab1" class="container">
							<div class="top-row margin_0 rev">
								<div className="left-section pull-left">
									<ul class="nav nav-pills">
										<li class="active">
											<Link to={`/revenue`} name={"max"} class="tab">
												Subscription
											</Link>
										</li>
										<li>
											<Link to={`/devhour`} name={"max"} class="tab">
												DevHours & Custom Invoice
											</Link>
										</li>
									</ul>
								</div>
								<div className="right-section">
									<div className="row">
										<div className="col-md-2 col-xs-6 filter_dept"> </div>
										{/* <div className="col-md-4 col-xs-6 filter_dept">
                                            <div class="searchTicket mob_customer">
                                                <div className="filter">
                                                    <select class="form-control" name="enterprise" id="enterprise" onChange={this.onEnterpriseChange} value={this.state.enterprise}>
                                                        <option value="">Standard Customers</option>
                                                        <option value="1">Key Account</option>
                                                    </select>
                                                    <i class="fal fa-angle-down"></i>
                                                </div>
                                            </div>
                                        </div> */}
										{/* <div className="col-md-3 col-xs-6 filter_dept">
                                            <div class="searchTicket mob_customer">
                                                <div className="filter">
                                                    <select value={this.state.curr_month} class="form-control" onChange={this.onMonthChange}>
                                                        <option value="">All Months</option>
                                                        {
                                                            this.state.str_month.map((value, key) =>
                                                                <option value={value.id}>{value.name}</option>
                                                            )
                                                        }
                                                    </select>
                                                    <i class="fal fa-angle-down"></i>
                                                </div>
                                            </div>
                                        </div> */}
										{/* <div className="col-md-3 col-xs-12">
                                            <div className="searchTicket emp_dept">
                                                <input type="text" class="form-control" name="revenue_search" id="revenue_search" autoComplete="off" placeholder="Search by keyword"  onChange={this.searchGrid} /><button type="button"><i className="fa fa-search"></i></button>
                                            </div>
                                        </div> */}
										<div className="col-md-4 col-xs-12"></div>
										<div className="col-md-6 col-xs-12">
											<div class="searchTicket emp_dept">
												<input
													type="text"
													class="form-control"
													id="searchsubscription"
													name="searchsubscription"
													placeholder="Search Company"
													onChange={this.searchChange}
												/>
												<button type="submit">
													<i class="fa fa-search"></i>
												</button>
											</div>
											<div class="searchTicket filter dept hidden-md">
												<i class="fal fa-filter"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row m_t_20 rev">
								<div class="col-md-4 col-xs-6">
									<div class="dash_top">
										<div>
											<h6> {this.state.quick_stats ? "$ " + this.state.quick_stats : "--"}</h6>
											<span>Revenue Last Month</span>
										</div>
									</div>
								</div>
								<div class="col-md-4 col-xs-6">
									<div class="dash_top">
										<div>
											<h6>
												{" "}
												{this.state.current_stats ? "$ " + this.state.current_stats : "--"}
											</h6>
											<span>Revenue current Month</span>
										</div>
									</div>
								</div>
								<div class="col-md-4 col-xs-12">
									<div class="dash_top">
										<div>
											<h6>
												{this.state.projected_revenue
													? "$ " + this.state.projected_revenue
													: "--"}
											</h6>
											<span>Projected Revenue for Next Month</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-content customer-tab clearfix">
							<div class="tab-pane active" id="Subscription">
								{/* <--modal start for Raise Invoice-!> */}
								<div class="modal fade" id="raiseInvoiceModal" role="dialog">
									<div class="modal-dialog modal-md">
										<div class="modal-content">
											<div class="modal-header">
												<button type="button" class="close" data-dismiss="modal">
													&times;
												</button>
												<h4 style={{ color: "black" }} class="modal-title">
													Raise Invoice
												</h4>
											</div>
											<div class="modal-body">
												<div class="form-group">
													<label
														class="span2 control-label"
														for="company"
														style={{ fontSize: "20px" }}
													>
														{this.state.studio_id.name}
													</label>
												</div>
												<input
													type="hidden"
													class="form-control"
													name="invoice_studio_id"
													value={this.state.studio_id.id}
													disabled
												/>
												<input
													type="hidden"
													class="form-control"
													name="invoice_user_id"
													value={this.state.user_id.id}
													disabled
												/>
												Title
												<input
													type="text"
													class="form-control"
													name="invoice_title"
													onKeyPress={this.spaceKeyPress}
													onChange={this.onChange}
													placeholder=""
												/>
												<span class="error">{this.state.errors["invoice_title"]}</span>
												<br></br>
												Description
												<input
													type="text"
													class="form-control"
													name="invoice_description"
													onKeyPress={this.spaceKeyPress}
													onChange={this.onChange}
													placeholder=""
												/>
												<span class="error">{this.state.errors["invoice_description"]}</span>
												<br></br>
												Amount($)
												<input
													type="text"
													class="form-control"
													name="invoice_amount"
													onKeyPress={this.spaceKeyPress}
													onChange={this.onChange}
													placeholder=""
												/>
												<span class="error">{this.state.errors["invoice_amount"]}</span>
												<br></br>
											</div>
											<div class="modal-footer">
												<button type="button" class="btn btn-blue" data-dismiss="modal">
													Cancel
												</button>
												<button
													type="button"
													name="submit_invoice"
													id="submit_invoice"
													class="btn btn-sky"
													onClick={() => this.submitInvoice()}
												>
													Submit Invoice
												</button>
											</div>
										</div>
									</div>
								</div>
								{/* <--modal end for Raise Invoice-!> */}
								{/* <--modal start for Pause Billing-!> */}
								<div class="modal fade" id={"pauseBillingModal"} role="dialog">
									<div class="modal-dialog modal-md">
										<div class="modal-content">
											<div class="modal-header">
												<button type="button" class="close" data-dismiss="modal">
													&times;
												</button>
												<h4 style={{ color: "black" }} class="modal-title">
													Pause Subscription Billing
												</h4>
											</div>
											<div class="modal-body" style={{ minHeight: "200px" }}>
												<div class="form-group">
													<label class="span2 control-label ttl">Package</label>
													<div class="span10">
														<div class="col-sm-4 pull-left">
															<label>
																<div
																	class="pull-left"
																	style={{ marginRight: "8px", marginTop: "-2px" }}
																>
																	<input
																		type="checkbox"
																		id="package_id"
																		value={this.state.package_details.id}
																		onClick={this.checkUncheckAllApp}
																	/>
																</div>
																{this.state.package_details.name}
															</label>
															<input
																type="hidden"
																value={this.state.paused_studio_id}
																name="data[Admin][studio_id]"
																readonly="readonly"
															/>
															<input
																type="hidden"
																id="pause_id_package"
																value=""
																name="data[Admin][package]"
																readonly="readonly"
															/>
															<input
																type="hidden"
																id="pause_id_applications"
																value=""
																name="data[Admin][applications]"
																readonly="readonly"
															/>
														</div>
														<div class="clearfix"></div>
													</div>
												</div>
												{this.state.paused_applications.length > 0 ? (
													<div class="form-group">
														<label class="span2 control-label ttl">Applications</label>
														<div class="span12">
															{this.state.paused_applications.map((app, key) => (
																<div class="col-sm-3 pull-left">
																	<label>
																		<div
																			class="pull-left"
																			style={{
																				marginRight: "8px",
																				marginTop: "-2px",
																			}}
																		>
																			{/* checkbox */}
																			{/* defaultChecked={app.is_selapps == 1} */}
																			<input
																				type="checkbox"
																				onClick={
																					app.is_selapps == 1
																						? app.is_paused_app == 1
																							? ""
																							: this.checkApplications
																						: ""
																				}
																				value={
																					app.is_selapps == 1 ? app.id : ""
																				}
																				name={
																					app.is_selapps == 1
																						? app.is_paused_app == 1
																							? ""
																							: "checked_application"
																						: ""
																				}
																				disabled={
																					app.is_selapps == 1
																						? app.is_paused_app == 1
																							? true
																							: ""
																						: true
																				}
																				class={
																					app.is_selapps == 1
																						? app.is_paused_app == 1
																							? "appchk"
																							: "appchk selappchk"
																						: "appchk"
																				}
																			/>
																		</div>
																		<span>
																			{app.is_selapps == 0 ? (
																				<span style={{ color: "#c4c4c4" }}>
																					{app.name}
																				</span>
																			) : (
																				<span>{app.name}</span>
																			)}
																			<br />
																			{app.is_paused_app == 1 ? (
																				<span style={{ color: "#FE0124" }}>
																					Paused
																				</span>
																			) : (
																				""
																			)}
																		</span>
																	</label>
																</div>
															))}
															<div class="clearfix"></div>
														</div>
														<div class="clearfix"></div>
													</div>
												) : (
													""
												)}
												<div class="form-group">
													<div class="span12">
														<div class="col-sm-3 pull-left">
															<label>
																<div
																	class="pull-left"
																	style={{ marginRight: "8px", marginTop: "-2px" }}
																>
																	<input
																		type="checkbox"
																		id="resume_id"
																		name="resume_id"
																		value="1"
																		onChange={this.resumeOn}
																	/>
																</div>
																Auto-resume on
															</label>
														</div>
														<div
															class="col-sm-3 pull-left"
															style={{ position: "absolute", left: "20%" }}
														>
															{/* datepicker */}
															<DatePicker
																readOnly={true}
																selected={this.state.date_of_resume}
																onChange={this.handleResumeDate}
																name="resume_date"
																minDate={moment()}
																disabled={this.state.datepicker}
															/>
														</div>
														<div class="clearfix"></div>
													</div>
												</div>
												<div class="form-group">
													<span class="error">{this.state.errors["resume_unchecked"]}</span>
												</div>
												<div class="form-group">
													Selected {this.state.app_data} are purchased by customer. Un-select
													checkbox will pause billing of corresponding {this.state.app_data}
												</div>
												<div class="form-group">
													Next Billing Cycle: {this.state.paused_billing_date}
												</div>
											</div>
											<div class="modal-footer">
												<button type="button" class="btn btn-blue" data-dismiss="modal">
													Cancel
												</button>
												<button
													type="button"
													name="pause_billing"
													id="pause_billing"
													class="btn btn-sky"
													onClick={() => this.pauseBilling()}
												>
													Pause Billing
												</button>
											</div>
										</div>
									</div>
								</div>
								{/* <--modal end for Pause Billing-!> */}
								{/* <--modal start for Resume Billing-!> */}
								<div class="modal fade" id={"resumeBillingModal"} role="dialog">
									<div class="modal-dialog modal-md">
										<div class="modal-content">
											<div class="modal-header">
												<button type="button" class="close" data-dismiss="modal">
													&times;
												</button>
												<h4 style={{ color: "black" }} class="modal-title">
													Resume Subscription Billing
												</h4>
											</div>
											<div class="modal-body" style={{ minHeight: "200px" }}>
												<div class="form-group">
													<label class="span2 control-label ttl">Package</label>
													<div class="span10">
														<div class="col-sm-4 pull-left">
															<label>
																<div
																	class="pull-left"
																	style={{ marginRight: "8px", marginTop: "-2px" }}
																>
																	<input
																		type="checkbox"
																		id="resume_package_id"
																		value={this.state.resume_package_details.id}
																		onClick={this.checkUncheckAllResumeApp}
																		class="checkallresumeapp"
																	/>
																</div>
																{this.state.resume_package_details.name}
															</label>
															<input
																type="hidden"
																value={this.state.resume_studio_id}
																name="data[Admin][studio_id]"
																readonly="readonly"
															/>
															<input
																type="hidden"
																id="resume_id_package"
																value=""
																name="data[Admin][package]"
																readonly="readonly"
															/>
															<input
																type="hidden"
																id="resume_id_applications"
																value=""
																name="data[Admin][applications]"
																readonly="readonly"
															/>
														</div>
														<div class="clearfix"></div>
													</div>
												</div>
												{this.state.resume_applications.length > 0 ? (
													<div class="form-group">
														<label class="span2 control-label ttl">Applications</label>
														<div class="span12">
															{this.state.resume_applications.map((app, key) => (
																<div class="col-sm-3 pull-left">
																	<label>
																		<div
																			class="pull-left"
																			style={{
																				marginRight: "8px",
																				marginTop: "-2px",
																			}}
																		>
																			{/* checkbox */}
																			<input
																				type="checkbox"
																				disabled={
																					app.resume_is_selapps == 1
																						? app.resume_is_paused_app == 1
																							? ""
																							: true
																						: true
																				}
																				value={
																					app.resume_is_selapps == 1
																						? app.resume_is_paused_app == 1
																							? app.id
																							: ""
																						: ""
																				}
																				class={
																					app.resume_is_selapps == 1
																						? app.resume_is_paused_app == 1
																							? "resume_selappchk"
																							: "resume_appchk"
																						: "resume_appchk"
																				}
																				onClick={
																					app.resume_is_selapps == 1
																						? app.resume_is_paused_app == 1
																							? this
																								.checkResumeApplications
																							: ""
																						: ""
																				}
																			/>
																		</div>
																		<span>
																			{app.resume_is_selapps == 0 ? (
																				<span style={{ color: "#c4c4c4" }}>
																					{app.name}
																				</span>
																			) : (
																				<span>{app.name}</span>
																			)}
																			{/* {app.name} */}
																			<br />
																			{app.resume_is_paused_app == 1 ? (
																				<span style={{ color: "#FE0124" }}>
																					Paused
																				</span>
																			) : (
																				""
																			)}
																		</span>
																	</label>
																</div>
															))}
															<div class="clearfix"></div>
														</div>
														<div class="clearfix"></div>
													</div>
												) : (
													""
												)}
												{this.state.resume_is_date_present == 1 ? (
													<div class="form-group">
														<div class="span12">
															<div class="col-sm-3 pull-left">
																<label>
																	<div
																		class="pull-left"
																		style={{
																			marginRight: "8px",
																			marginTop: "-2px",
																		}}
																	>
																		<input
																			type="checkbox"
																			id="auto_resume_id"
																			name="auto_resume_id"
																			value="1"
																			onChange={this.auto_resumeOn}
																		/>
																	</div>
																	Auto-resume on
																</label>
															</div>
															<div
																class="col-sm-3 pull-left"
																style={{ position: "absolute", left: "20%" }}
															>
																{/* datepicker */}
																<DatePicker
																	readOnly={true}
																	selected={this.state.resumeDate}
																	onChange={this.handleResumeDateAfterPause}
																	name="resume_date"
																	minDate={moment()}
																	disabled={this.state.datepicker_resume}
																/>
															</div>
															<div class="clearfix"></div>
														</div>
													</div>
												) : (
													""
												)}
												<div class="form-group">
													<span class="error">
														{this.state.errors["resume_billing_error"]}
													</span>
												</div>
												<div class="form-group">
													Un-selected {this.state.resume_app_data} are purchased by customer.
													Un-select checkbox will pause billing of corresponding{" "}
													{this.state.resume_app_data}
												</div>
												<div class="form-group">
													Next Billing Cycle: {this.state.resume_billing_date}
												</div>
											</div>
											<div class="modal-footer">
												<button type="button" class="btn btn-blue" data-dismiss="modal">
													Cancel
												</button>
												<button
													type="button"
													name="resume_billing_button"
													id="resume_billing_button"
													class="btn btn-sky"
													onClick={() => this.resumeBilling()}
												>
													Resume Billing
												</button>
											</div>
										</div>
									</div>
								</div>
								{/* <--modal end for Resume Billing-!> */}
								{this.getSubscriptionDetails()}
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		);
	}
}
export default Revenue;



// WEBPACK FOOTER //
// ./src/components/revenue/Revenue.js